import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { COLORS } from "constants/colors"; // COLORS をインポート

const ChiStyledButton = styled(Button)(({ theme }) => ({
  width: "80%",
  fontSize: "18px",
  fontFamily: '"Noto Serif JP", serif',
  fontWeight: "bold",
  padding: "8px",
  borderRadius: "27px",
  border: "2px solid white",
  height: "54px",
  background: "transparent",
  textTransform: "none",
  "&:hover": {
    opacity: 0.9, // ホバー時の軽いエフェクト
  },
}));

export default ChiStyledButton;
